<template>
  <b-row class="mb-3">
    <b-col md="2">
      <label>Plan*</label>
    </b-col>
    <b-col md="4">
      <b-form-select v-model="oferta.planId" :disabled="disabled">
        <b-form-select-option disabled selected value=""> Seleccione plan de precios </b-form-select-option>
        <b-form-select-option v-for="p in planes" :key="p.id" :value="p.id">
          {{ p.nombre }}
          ({{ describirPlan(p) }})
        </b-form-select-option>
      </b-form-select>
    </b-col>
    <b-col md="2">
      <label>Nº Empleados*</label>
    </b-col>
    <b-col md="4">
      <b-form-input
        v-model="oferta.numeroUsuarios"
        type="number"
        :max="maxUsuarios"
        placeholder="Nº usuarios"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import { describirPlan } from "@/services/planes";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "planes", "plan", "maximoNumeroUsuarios"]),
    maxUsuarios() {
      return this.plan.maximoNumeroUsuarios || 999999;
    },
  },
  methods: { describirPlan },
};
</script>
